var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"tiptap-content",domProps:{"innerHTML":_vm._s(_vm.privacy)}}),_c('v-btn',{attrs:{"id":"btnScroll","icon":""},on:{"click":_vm.topFunction}},[_c('v-icon',[_vm._v("mdi-arrow-up")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }